import { render, staticRenderFns } from "./product-slider.vue?vue&type=template&id=b6cb88b8&scoped=true"
import script from "./product-slider.vue?vue&type=script&lang=js"
export * from "./product-slider.vue?vue&type=script&lang=js"
import style0 from "./product-slider.vue?vue&type=style&index=0&id=b6cb88b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb88b8",
  null
  
)

export default component.exports